/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {DeleteGrantRequest} from '../models/DeleteGrantRequest';
import type {EntitlementId} from '../models/EntitlementId';
import type {Error} from '../models/Error';
import type {Grant} from '../models/Grant';
import type {GrantList} from '../models/GrantList';
import type {UpdateGrantRequest} from '../models/UpdateGrantRequest';

export interface CreateGrant$Request {
    grant: Grant;
}

export interface CreateGrant$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const createGrantRequest = createAction<PayloadData<void, CreateGrant$Request>>('ENTITLEMENTS_GRANT__CREATE_GRANT__REQUEST');
export const createGrantSuccess = createAction<PayloadData<EntitlementId, CreateGrant$Request>>('ENTITLEMENTS_GRANT__CREATE_GRANT__SUCCESS');
export const createGrantFailure = createAction<PayloadData<Error, CreateGrant$Request, true>>('ENTITLEMENTS_GRANT__CREATE_GRANT__FAILURE');

export const createGrantActions = [
    createGrantRequest,
    createGrantSuccess,
    createGrantFailure
] as const;

/**
 * @param {Grant} meta.grant
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const createGrant = (meta: CreateGrant$Request, config?: CreateGrant$Config) => {
    return {
        CALL_API: {
            types: createGrantActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/entitlements/grants`,
            TRANSPORT_REQUEST_BODY: meta.grant,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface DeleteGrant$Request {
    grantId: string;
    deleteGrantRequest: DeleteGrantRequest;
}

export interface DeleteGrant$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const deleteGrantRequest = createAction<PayloadData<void, DeleteGrant$Request>>('ENTITLEMENTS_GRANT__DELETE_GRANT__REQUEST');
export const deleteGrantSuccess = createAction<PayloadData<void, DeleteGrant$Request>>('ENTITLEMENTS_GRANT__DELETE_GRANT__SUCCESS');
export const deleteGrantFailure = createAction<PayloadData<Error, DeleteGrant$Request, true>>('ENTITLEMENTS_GRANT__DELETE_GRANT__FAILURE');

export const deleteGrantActions = [
    deleteGrantRequest,
    deleteGrantSuccess,
    deleteGrantFailure
] as const;

/**
 * @param {string} meta.grantId
 * @param {DeleteGrantRequest} meta.deleteGrantRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const deleteGrant = (meta: DeleteGrant$Request, config?: DeleteGrant$Config) => {
    return {
        CALL_API: {
            types: deleteGrantActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/entitlements/grants/${meta.grantId}`,
            TRANSPORT_REQUEST_BODY: meta.deleteGrantRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetGrantsByIds$Request {
    requestBody: Array<string>;
}

export interface GetGrantsByIds$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getGrantsByIdsRequest = createAction<PayloadData<void, GetGrantsByIds$Request>>('ENTITLEMENTS_GRANT__GET_GRANTS_BY_IDS__REQUEST');
export const getGrantsByIdsSuccess = createAction<PayloadData<{ [key: string]: Grant; }, GetGrantsByIds$Request>>('ENTITLEMENTS_GRANT__GET_GRANTS_BY_IDS__SUCCESS');
export const getGrantsByIdsFailure = createAction<PayloadData<Error, GetGrantsByIds$Request, true>>('ENTITLEMENTS_GRANT__GET_GRANTS_BY_IDS__FAILURE');

export const getGrantsByIdsActions = [
    getGrantsByIdsRequest,
    getGrantsByIdsSuccess,
    getGrantsByIdsFailure
] as const;

/**
 * @param {Array<string>} meta.requestBody
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getGrantsByIds = (meta: GetGrantsByIds$Request, config?: GetGrantsByIds$Config) => {
    return {
        CALL_API: {
            types: getGrantsByIdsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/entitlements/grants`,
            TRANSPORT_REQUEST_BODY: meta.requestBody,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetGrantsWithoutRelations$Request {
    pageSize: number;
    pageNumber: number;
}

export interface GetGrantsWithoutRelations$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getGrantsWithoutRelationsRequest = createAction<PayloadData<void, GetGrantsWithoutRelations$Request>>('ENTITLEMENTS_GRANT__GET_GRANTS_WITHOUT_RELATIONS__REQUEST');
export const getGrantsWithoutRelationsSuccess = createAction<PayloadData<GrantList, GetGrantsWithoutRelations$Request>>('ENTITLEMENTS_GRANT__GET_GRANTS_WITHOUT_RELATIONS__SUCCESS');
export const getGrantsWithoutRelationsFailure = createAction<PayloadData<Error, GetGrantsWithoutRelations$Request, true>>('ENTITLEMENTS_GRANT__GET_GRANTS_WITHOUT_RELATIONS__FAILURE');

export const getGrantsWithoutRelationsActions = [
    getGrantsWithoutRelationsRequest,
    getGrantsWithoutRelationsSuccess,
    getGrantsWithoutRelationsFailure
] as const;

/**
 * @param {number} meta.pageSize
 * @param {number} meta.pageNumber
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getGrantsWithoutRelations = (meta: GetGrantsWithoutRelations$Request, config?: GetGrantsWithoutRelations$Config) => {
    const TRANSPORT_GET_PARAMS = {
        pageSize: meta.pageSize,
        pageNumber: meta.pageNumber,
    };
    return {
        CALL_API: {
            types: getGrantsWithoutRelationsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/entitlements/grants`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface UpdateGrant$Request {
    grantId: string;
    updateGrantRequest: UpdateGrantRequest;
}

export interface UpdateGrant$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const updateGrantRequest = createAction<PayloadData<void, UpdateGrant$Request>>('ENTITLEMENTS_GRANT__UPDATE_GRANT__REQUEST');
export const updateGrantSuccess = createAction<PayloadData<void, UpdateGrant$Request>>('ENTITLEMENTS_GRANT__UPDATE_GRANT__SUCCESS');
export const updateGrantFailure = createAction<PayloadData<Error, UpdateGrant$Request, true>>('ENTITLEMENTS_GRANT__UPDATE_GRANT__FAILURE');

export const updateGrantActions = [
    updateGrantRequest,
    updateGrantSuccess,
    updateGrantFailure
] as const;

/**
 * @param {string} meta.grantId
 * @param {UpdateGrantRequest} meta.updateGrantRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const updateGrant = (meta: UpdateGrant$Request, config?: UpdateGrant$Config) => {
    return {
        CALL_API: {
            types: updateGrantActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/entitlements/grants/${meta.grantId}`,
            TRANSPORT_REQUEST_BODY: meta.updateGrantRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

